import { useEffect, useState } from 'react';
import { Content, Title, InputFormTable } from 'components';
import { Select } from 'antd';
import { useGetTags } from 'hooks/TagHooks';
import styles from '../styles';
import {
  useProductTagState,
  useProductTagDispatch,
} from '../context/ProductTagProvider';
import { TagsOutlined } from '@ant-design/icons';

const ProductHashtagInformation = ({ defaultData }) => {
  const response = useGetTags();
  const { tags } = useProductTagState();
  const dispatch = useProductTagDispatch();
  const [tagList, setTagList] = useState([]);

  const getTagSelectOptions = () => {
    return tagList
      .filter((item) => item.is_show === 'Y')
      .map((item) => ({
        label: item.tag_name,
        value: item.tag_id,
      }));
  };
  const handleChangeTag = (items) => {
    const selectedTag = tagList.filter(({ tag_id }) => items.includes(tag_id));
    // .filter((item) => item.is_show === 'Y');

    dispatch({ type: 'SET_TAG', value: selectedTag });
  };
  // const handleChangeTag = (items) => {
  //   const selectedTag = tagList
  //     .filter(({ tag_id }) => {
  //       const isFindTag = items.some((item) => item === tag_id);

  //       if (isFindTag) {
  //         return true;
  //       }

  //       return false;
  //     })
  //     .filter((item) => item.is_show === 'Y');

  //   dispatch({ type: 'SET_TAG', value: selectedTag });
  // };

  const form = [
    {
      label: '태그',
      direction: 'column',
      form: [
        {
          input: (
            <>
              <Select
                mode="multiple"
                allowClear
                style={{ width: '100%' }}
                options={getTagSelectOptions()}
                onChange={handleChangeTag}
                // defaultValue={tags.map((tag) => ({
                //   label: tag.tag_name,
                //   value: tag.tag_id,
                // }))}
                value={tags
                  .filter((tag) => tagList.some((t) => t.tag_id === tag.tag_id)) // 기존 선택된 태그가 tagList에 존재하는지 확인
                  .map((tag) => ({
                    label: tag.tag_name, // 기존 선택된 태그는 label 유지
                    value: tag.tag_id,
                  }))}
              />
            </>
          ),
          fullscreen: true,
        },
      ],
    },
  ];

  useEffect(() => {
    if (response && response.data) {
      const { data } = response.data;
      setTagList(data);
    }
  }, [response]);

  useEffect(() => {
    if (defaultData && defaultData?.tag?.length) {
      dispatch({ type: 'SET_TAG', value: defaultData.tag });
    }
  }, [defaultData]);

  return (
    <Content
      maxWidth={'100%'}
      padding={20}
      borderRadius={4}
      style={{ marginBottom: 25 }}
      className="boxShadow"
    >
      <Title size={5} align="left" style={{ marginBottom: 10 }}>
        <TagsOutlined /> 태그 설정
      </Title>
      <InputFormTable form={form} />
    </Content>
  );
};

export default ProductHashtagInformation;
